<template>
  <div>
    <control-codes :order-service="orderService" class="controlcodes-block" />
  </div>
</template>

<script>
import ControlCodes from '@/components/generic/container/ControlCodes.vue'
import purchaseOrderService from '@/services/purchaseOrderService.js'

export default {
  components: {
    ControlCodes,
  },
  data() {
    return {
      orderService: purchaseOrderService,
    }
  },
}
</script>

<style lang="scss" scoped>
.controlcodes-block {
  margin-bottom: 2em;
}
</style>
